export type DividerProps = {
  my: number;
};

const Divider = (props: DividerProps) => {
  const { my } = props;

  return (
    <div
      className={`h-[1px] w-full bg-gray-10`}
      style={{ marginTop: `${my}px`, marginBottom: `${my}px` }}
    />
  );
};

export default Divider;
